export const uploadConst = {
    UPLOAD_REQUEST: 'UPLOAD_REQUEST',
    UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
    UPLOAD_FAILURE: 'UPLOAD_FAILURE',

    UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',

    UPLOAD_CANCEL: 'UPLOAD_CANCEL'
};
